import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButtonWithNotification from '@wix/da-ds/pkg/Buttons/IconButtonWithNotification';
import CartIcon from '@wix/da-ds/pkg/Icons/Cart';
var CartIconButton = function (_a) {
    var cartCount = _a.cartCount, className = _a.className, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName;
    var t = useTranslation().t;
    return (React.createElement(IconButtonWithNotification, { icon: CartIcon, size: "medium", notificationColor: "green", className: className, iconButtonClassName: iconClassName, numberClassName: numberClassName, count: cartCount, biData: BiData({
            evid: 700,
            link_url: URLS.CART,
            link_name: 'cart',
            indicator: cartCount,
        }), href: URLS.CART, "aria-label": t('siteHeader.a11y.cart.withItems', {
            formattedCount: cartCount,
        }) }));
};
CartIconButton.displayName = 'CartIconButton';
export default CartIconButton;
//# sourceMappingURL=CartIconButton.js.map